export const formatCep = (value) => {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 8);
  return digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
};

export async function lookupCep(value) {
  const cep = String(value || '').replace(/\D/g, '');
  if (cep.length !== 8) throw new Error('Digite um CEP com 8 números.');

  let data = null;
  try {
    const response = await fetch('https://viacep.com.br/ws/' + cep + '/json/');
    if (response.ok) data = await response.json();
    if (data?.erro) data = null;
  } catch (_) {
    // Tenta a fonte alternativa abaixo.
  }
  if (!data?.localidade) {
    try {
      const response = await fetch('https://brasilapi.com.br/api/cep/v1/' + cep);
      if (response.ok) {
        const alternative = await response.json();
        data = { ...alternative, localidade: alternative.city, uf: alternative.state, logradouro: alternative.street, bairro: alternative.neighborhood };
      }
    } catch (_) {
      // A mensagem abaixo informa que nao foi possivel resolver o CEP.
    }
  }
  if (!data?.localidade || !data?.uf) throw new Error('CEP não encontrado. Confira os números e tente novamente.');
  return {
    cep,
    city: data.localidade + ' - ' + data.uf,
    address: [data.logradouro, data.bairro].filter(Boolean).join(', ')
  };
}
